/**
 * The below file contains the constants used in the Fire Category
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

/**Constants for fire category */
export const GET_ALL_FIRE_CATEGORY = "GET_ALL_FIRE_CATEGORY";
export const SET_ALL_FIRE_CATEGORY = "SET_ALL_FIRE_CATEGORY";
/**Constants for fire category */
